<template>
  <section id="SectionOffices" :class="background">
    <Wrap>
      <slot name="title" />
      <div v-for="(officesType, key) in officesGrouped" :key="key" class="type">
        <div v-if="doShowType" class="header">
          <h2> {{ key }}</h2>
        </div>
        <Row class="office-row">
          <Column
            v-for="office in officesType"
            :key="office.id"
            class="office"
            :lg="3"
            :sm="6">
            <Office :office="office" />
          </Column>
        </Row>
      </div>
    </Wrap>
  </section>
</template>

<script>
import { actions, getters } from 'views/utils'
import Office from './Office'

export default {
  components: { Office },
  props: {
    background: { type: String, default: 'white' },
    doShowType: { type: Boolean, default: true },
    customQuery: { type: Object, default: () => ({}) },
  },
  data() {
    return {
      contact: this.$store.getters.contactFactory(),
    }
  },
  computed: {
    activeType() {
      return this.officeTypes[this.activeTypeIndex]
    },
    offices() {
      const query = {
        locale: this.locale,
        ...this.customQuery,
      }

      return this.query('office', query)
    },
    officesGrouped() {
      return this.groupByKey(this.offices, 'type')
    },
    ...getters(),
  },
  methods: {
    groupByKey(items, key) {
      const groups = {}
      items.forEach((items) => {
        if (!groups[items[key]]) {
          groups[items[key]] = [items]
          return
        }
        groups[items[key]].push(items)
      })
      return groups
    },
    // sortByName(items) {
    //   return items.sort((a, b) => a.name.localeCompare(b.name))
    // },
    ...actions('FETCH_OFFICE'),
  },

  created() {
    this.LOAD(this.FETCH_OFFICE())
  },
}
</script>

<style lang="scss">
$_border-color: rgba($border-color, 0.3);

#SectionOffices {
  text-align: center;
  @include md {
    text-align: left;
  }

  .type {
    border-bottom: 1px solid $_border-color;

    > .header {
      margin: 2rem 0 3rem;
    }

    &:first-child {
      > .header {
        margin-top: 0;
      }
    }

    &:last-child {
      border: none;
    }
  }

  > .Wrap {
    padding: 0 2rem;
  }
}
</style>
